import Swiper from "swiper";

class ModuleSlider {
  constructor() {
    this.trigger = document.querySelector('[data-trigger="module-slider"]');
    this._init();
  }

  _init() {
    this.swiper = new Swiper(this.trigger, {
      breakpoints: {
        1023: {
          slidesPerView: 1
        }
      },
      slidesPerView: "auto",
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  }
}

export const moduleSlider = new ModuleSlider();
